<template>
  <div>
    <vsmallheader></vsmallheader>
    <div class="uploadFileBox">
        <div style="margin-top:20px;margin-bottom: 20px;display: flex;">
            <div style="font-size:14px;color:#888;display:flex;align-items: center">
            <img src="@/assets/resource/adresst.png" style="width:15px;height:15px;margin-right:5px" />
            当前位置：
            </div>
            <span
            style="font-size: 14px;"
            >首页 / 文件上传</span>
        </div>
        <div class="upFileBox">
            <div>
                <el-upload
                    :headers="headers"
                    class="upload-demo"
                    drag
                    ref="my-upload"
                    accept=".7z, .zip, .rar, .zipx"
                    action="/bigfile/File/UploadBigFile"
                    :on-success="fileSuccess"
                    :on-error="fileError"
                    :on-exceed="exceed"
                    :limit="1"
                    :before-upload="beforeFileSuccess"
                    :before-remove="beforeRemove"
                >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                    将文件拖到此处，或
                    <em>点击上传</em>
                    </div>
                </el-upload>
            </div>
            <div class="fileTitBox">
                <div>1、一次上传只支持上传一个文件，上传的文件大小不超过10G</div>
                <div>2、上传的压缩文件格式支持 .7z, .zip, .rar, .zipx</div>
                <div>3、加载到100%后需等待服务器接收完成，请勿在文件上传过程中关闭当前页面，以防文件上传中断</div>
                <div class="fileTit">
                    <div>上传文件名称：</div>
                    <el-input
                    size="small"
                    style="width:400px;"
                    v-model="uploadFrom.fileName"
                    :disabled="uploadFrom.filePath ? false : true"
                    >
                    </el-input>
                </div>
                <div style="margin-top:50px;">
                    <el-button @click="preservationPlay" type="primary">保存</el-button>
                </div>
            </div>
        </div>
        <div class="ListTitle">
            上传历史记录
        </div>
        <div style="text-align:left;margin: 0 50px 20px 0">
            <el-button @click="beforeDelFile" size="small" type="danger">批量删除</el-button> 
        </div>
        <div>
            <el-table
            :data="list"
            class="fileListBox"
            border
            style="width: 100%;"
            @selection-change="handleSelectionChange"
            >
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column align="center" prop="createtime" label="上传时间" width="150"></el-table-column>
            <el-table-column align="center" prop="filename" label="文件名称" min-width="200"></el-table-column>
            <el-table-column align="center" prop="filesize" label="文件大小（MB）" width="150"></el-table-column>
            <el-table-column align="center" prop="createname" label="创建人" width="150"></el-table-column>
            <el-table-column align="center" label="操作" width="150">
                <template slot-scope="scope">
                    <el-button @click="downFile(scope.row)" type="primary" plain>下载</el-button>
                </template>
            </el-table-column>
            </el-table>
            <div class="fbootomBar">
                <el-pagination
                    style="margin-right:30px;"
                    background
                    prev-text="上一页"
                    next-text="下一页"
                    layout="total,prev, pager, next,jumper"
                    :page-size="listQuery.limit"
                    :current-page.sync="listQuery.page"
                    :total="total"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                ></el-pagination>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import * as homeAPI from '@/api/clientshome/index.js';
import vsmallheader from '@/views/smallHeader/index';
import { getInfo} from '@/utils/auth';
export default {
    name: 'upFileWork',
    components:{
        vsmallheader,
    },
    computed: {
        headers() {
            return {
                Authorization: 'Bearer ' + this.tokens,
            };
        },
    },
    data(){
        return{
            upFileUrl:'',
            fileName: '',
            selectList:[],
            listQuery:{
                page:1,
                limit:10,
                name:null,
                userId:null,
            },
            uploadFrom:{
                fileName: '',
                filePath: '',
                fileSize: '',
                createName: null,
                createId: null,
            },
            list:[],
            loadding:null,
            total: 0,
            tokens: null,
        }
    },
    created(){
        this.getInfo();
        this.getList();
    },
    methods:{
        getInfo(){
            if(getInfo('infos')){
                let info = JSON.parse(getInfo('infos'));
                this.uploadFrom.createId = info.id;
                this.uploadFrom.createName = info.name;
                this.tokens = info.token;
                this.listQuery.userId = info.id;
            }else if(this.$store.state.User.tokens){
                let info = this.$store.state.User.infos;
                this.uploadFrom.createId = info.id;
                this.uploadFrom.createName = info.name;
                this.tokens = info.token;
                this.listQuery.userId = info.id;
            }else{
                this.$router.replace({path:'/'});
            }
        },
        getList(){
            homeAPI.getUserFileList(this.listQuery).then(res=>{
                this.list = res.data || [];
                this.total = res.count;
            })
        },
        //上传成功后
        fileSuccess(response, file, fileList) {
            this.loadding.close();
            let that = this;
            let data = response.result;
            let str = data.split(',')[0];
            let size = data.split(',')[1];
            this.uploadFrom.filePath = str;
            this.uploadFrom.fileSize = size;
        },
        //上传失败
        fileError(response, file, fileList){
            this.loadding.close();
            this.$message.error('上传失败！');
        },
        //上传提示
        exceed() {
            this.$message.error('最多只能上传一个文件');
        },
        //上传前
        beforeFileSuccess(file) {
            this.uploadFrom.fileName = file.name.split('.')[0];
            var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            const extension = testmsg === '7z';
            const extension2 = testmsg === 'zip';
            const extension3 = testmsg === 'rar';
            const extension4 = testmsg === 'zipx';
            const isLt2M = file.size / 1024 / 1024 < 1024*10;
            if (!extension && !extension2 && !extension3 && !extension4) {
                this.$message({
                    message: '上传文件只能是 mp4、RMVB、FLV、AVI格式!',
                    type: 'warning',
                });
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传文件大小不能超过 10GB!');
                return false;
            }
            this.loadding = this.$loading({
                lock: true,
                text: '文件数据正在上传中，请稍后......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        beforeRemove(file,fileList){
            this.uploadFrom.filePath = null;
            this.uploadFrom.fileSize = null;
            this.uploadFrom.fileName = '';
        },
        //保存
        preservationPlay(){
            if(!this.uploadFrom.filePath){
                this.$message.error('请上传文件！');
                return false
            }
            if(!this.uploadFrom.fileName){
                this.$message.error('文件名称不能为空！');
                return false
            }
            homeAPI.addUserFile(this.uploadFrom).then(res=>{
                if(res.message){
                    this.$message.success(res.message);
                }
                this.getList();
            })
        },
        beforeDelFile(){
            if(this.selectList.length == 0){
                this.$message.error('请至少选中一个！');
                return false
            }
            this.$confirm('确认删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delFile();
            }).catch(() => {});
        },
        //删除
        delFile(){
            homeAPI.deleteUserFile(this.selectList).then(res=>{
                let str = res.message ? res.message : '';
                if(str){
                    this.$message.success(str);
                }
                this.getList();
            })
        },
        //选中
        handleSelectionChange(val){
            this.selectList = val.map(item=>item.id);
        },
        //下载
        downFile(data){
            window.open(data.filepath);
        },
        handleCurrentChange(val){
            this.listQuery.page = val;
            this.getList();
        },
        handleSizeChange(val){}
    }
}
</script>

<style scoped>
.uploadFileBox{
    margin: 0 auto;
    width: 1200px;
    min-height: 860px;
}
.upFileBox{
    display: flex;
    margin-top: 80px;
}
.fileTitBox{
    margin-left: 50px;
    margin-top: 30px;
    font-size: 16px;
    color: rgb(167, 167, 167);
}
.fileTitBox>div{
    margin-bottom: 20px;
}
.fileTit{
    display: flex;
    align-items: center;
    color: #000;
}
.ListTitle{
    margin: 50px 0px;
    font-size: 18px;
    font-weight: 700;
}
/deep/.fileListBox .el-table__empty-block{
    height: 500px !important;
    line-height: 500px;
}
.fbootomBar{
    margin-top: 20px;
    padding-bottom: 20px;
    width: 100%;
    text-align: right;
}
</style>